<script setup lang="ts">
import { computed } from 'vue'
import { useAppStore } from '@/store/modules/app'
import { ConfigGlobal } from '@/components/ConfigGlobal'
import { isDark } from '@/utils/is'
import { useDesign } from '@/hooks/web/useDesign'
import { useCache } from '@/hooks/web/useCache'
import { useI18n } from '@/hooks/web/useI18n';
import { APP_VERSION } from './config/global'
const { t } = useI18n()
const { getPrefixCls } = useDesign()

const prefixCls = getPrefixCls('app')

const appStore = useAppStore()

const currentSize = computed(() => appStore.getCurrentSize)

const greyMode = computed(() => appStore.getGreyMode)

const { wsCache } = useCache()

// 根据浏览器当前主题设置系统主题色
// const setDefaultTheme = () => {
//   if (wsCache.get('isDark')) {
//     appStore.setIsDark(wsCache.get('isDark'))
//     return
//   }
//   const isDarkTheme = isDark()
//   appStore.setIsDark(isDarkTheme)
// }

// setDefaultTheme()

const setTitle = ()=>{
  appStore.setTitle(t('portal.title'))
}
setTitle()
appStore.setVersion(APP_VERSION)
console.log('v:',APP_VERSION)
</script>

<template>
  <ConfigGlobal :size="currentSize">
    <RouterView :class="greyMode ? `${prefixCls}-grey-mode` : ''" />
  </ConfigGlobal>
</template>

<style lang="less">
@prefix-cls: ~'@{namespace}-app';

.size {
  width: 100%;
  height: 100%;
}

html,
body {
  // padding: 0 !important;
  margin: 0;
  overflow: hidden;
  position: relative;
  .size;

  #app {
    .size;
  }
}

.@{prefix-cls}-grey-mode {
  filter: grayscale(100%);
}
</style>
